import React, { useState, useEffect, useContext } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const ProtectedRoute = ({ children, requireSubscription = false }) => {
  const { user, loading, subscriptionStatus, checkAndRedirectSubscription } = useContext(AuthContext);
  const [checkingSubscription, setCheckingSubscription] = useState(requireSubscription);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && user && requireSubscription) {
      const checkSubscription = async () => {
        await checkAndRedirectSubscription(navigate);
        setCheckingSubscription(false);
      };
      
      checkSubscription();
    } else {
      setCheckingSubscription(false);
    }
  }, [loading, user, checkAndRedirectSubscription, navigate, requireSubscription]);

  // Show loading while checking auth or subscription
  if (loading || checkingSubscription) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Use a simpler check for subscription status as a fallback
  // in case the async check in useEffect doesn't redirect
  if (requireSubscription && 
      subscriptionStatus && 
      !subscriptionStatus.active) {
    return <Navigate to="/pricing" state={{ from: location }} replace />;
  }

  // Render children if all conditions are met
  return children;
};

export default ProtectedRoute; 